import dutch from '../../assets/translations/dutch.json'
import english from '../../assets/translations/english.json'
import { createContext, ReactNode, useState } from 'react'


export const LanguageContext = createContext({
  strings: dutch,
  switchLanguage: (keyword: string) => {
  },
  current: 'nl'
})

const LanguageContextProvider = (props: { children: ReactNode }) => {
  const params = new URLSearchParams(window.location.search)
  const isEnglish = params.get('lang') === 'en'
  const initialLanguage = isEnglish ? 'en' : 'nl'
  const [language, setLanguage] = useState(initialLanguage)
  const langJson = language === 'nl' ? dutch : english
  const switchLanguage = (keyword: string) => setLanguage(keyword)
  
  return (
    <LanguageContext.Provider value={{ strings: langJson, switchLanguage, current: language }}>
      {props.children}
    </LanguageContext.Provider>
  )
}

export default LanguageContextProvider
